export const getMediaUrl = async (url, downloadName) => {
  try {
    if (!url) return;

    // 🔍 wykrycie external URL
    const isExternal = url.startsWith("http://") || url.startsWith("https://");

    // 🌍 external → NIE używamy fetch (CORS!)
    if (isExternal) {
      window.open(url, "_blank");
      return;
    }

    // 📄 nazwa pliku
    let fileName = downloadName || url.split('/').pop();
    fileName = fileName.split('?')[0];

    const lastSegment = fileName.split('/').pop();
    const parts = lastSegment.split('.');
    const extension = parts.length > 1 ? parts.pop().toLowerCase() : 'attachment';
    fileName = parts.length > 0 ? lastSegment : 'attachment';

    const viewInBrowserExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'gif'];

    // 🔐 fetch dla secure_media (z cookies)
    const response = await fetch(url, { credentials: 'include' });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);

    if (viewInBrowserExtensions.includes(extension)) {
      window.open(objectUrl, '_blank');
    } else {
      const link = document.createElement('a');
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);

  } catch (error) {
    console.error("Download error:", error);
  }
};